export interface VerseReference {
    book: BibleBook;
    chapter: number;
    verse: number;
}
export type BibleVersion = 'csb' | 'esv' | 'kjv' | 'nasb' | 'niv' | 'nkjv';
export type BibleBook =
    | 'Genesis' | 'Exodus' | 'Leviticus' | 'Numbers' | 'Deuteronomy'
    | 'Joshua' | 'Judges' | 'Ruth' | '1 Samuel' | '2 Samuel' | '1 Kings' | '2 Kings' | '1 Chronicles' | '2 Chronicles' | 'Ezra' | 'Nehemiah' | 'Esther'
    | 'Job' | 'Psalm' | 'Proverbs' | 'Ecclesiastes' | 'Song of Solomon'
    | 'Isaiah' | 'Jeremiah' | 'Lamentations' | 'Ezekiel' | 'Daniel'
    | 'Hosea' | 'Joel' | 'Amos' | 'Obadiah' | 'Jonah' | 'Micah' | 'Nahum' | 'Habakkuk' | 'Zephaniah' | 'Haggai' | 'Zechariah' | 'Malachi'
    | 'Matthew' | 'Mark' | 'Luke' | 'John' | 'Acts'
    | 'Romans' | '1 Corinthians' | '2 Corinthians' | 'Galatians' | 'Ephesians' | 'Philippians' | 'Colossians' | '1 Thessalonians' | '2 Thessalonians' | '1 Timothy' | '2 Timothy' | 'Titus' | 'Philemon' | 'Hebrews' | 'James' | '1 Peter' | '2 Peter' | '1 John' | '2 John' | '3 John' | 'Jude'
    | 'Revelation';
export type BibleSection = 'pentateuch' | 'historical' | 'wisdom' | 'majorProphets' | 'minorProphets' | 'gospelsAndActs' | 'paulineEpistles' | 'generalEpistles' | 'revelation';
export interface BibleBookInfo {
    name: BibleBook;
    section: BibleSection;
    sortOrder: number;
    numChapters: number;
}

export const BIBLE_BOOKS: readonly BibleBookInfo[] = [
    { name: 'Genesis', section: 'pentateuch', sortOrder: 0, numChapters: 50 },
    { name: 'Exodus', section: 'pentateuch', sortOrder: 1, numChapters: 40 },
    { name: 'Leviticus', section: 'pentateuch', sortOrder: 2, numChapters: 27 },
    { name: 'Numbers', section: 'pentateuch', sortOrder: 3, numChapters: 36 },
    { name: 'Deuteronomy', section: 'pentateuch', sortOrder: 4, numChapters: 34 },
    { name: 'Joshua', section: 'historical', sortOrder: 5, numChapters: 24 },
    { name: 'Judges', section: 'historical', sortOrder: 6, numChapters: 21 },
    { name: 'Ruth', section: 'historical', sortOrder: 7, numChapters: 4 },
    { name: '1 Samuel', section: 'historical', sortOrder: 8, numChapters: 31 },
    { name: '2 Samuel', section: 'historical', sortOrder: 9, numChapters: 24 },
    { name: '1 Kings', section: 'historical', sortOrder: 10, numChapters: 22 },
    { name: '2 Kings', section: 'historical', sortOrder: 11, numChapters: 25 },
    { name: '1 Chronicles', section: 'historical', sortOrder: 12, numChapters: 29 },
    { name: '2 Chronicles', section: 'historical', sortOrder: 13, numChapters: 36 },
    { name: 'Ezra', section: 'historical', sortOrder: 14, numChapters: 10 },
    { name: 'Nehemiah', section: 'historical', sortOrder: 15, numChapters: 13 },
    { name: 'Esther', section: 'historical', sortOrder: 16, numChapters: 10 },
    { name: 'Job', section: 'wisdom', sortOrder: 17, numChapters: 42 },
    { name: 'Psalm', section: 'wisdom', sortOrder: 18, numChapters: 150 },
    { name: 'Proverbs', section: 'wisdom', sortOrder: 19, numChapters: 31 },
    { name: 'Ecclesiastes', section: 'wisdom', sortOrder: 20, numChapters: 12 },
    { name: 'Song of Solomon', section: 'wisdom', sortOrder: 21, numChapters: 8 },
    { name: 'Isaiah', section: 'majorProphets', sortOrder: 22, numChapters: 66 },
    { name: 'Jeremiah', section: 'majorProphets', sortOrder: 23, numChapters: 52 },
    { name: 'Lamentations', section: 'majorProphets', sortOrder: 24, numChapters: 5 },
    { name: 'Ezekiel', section: 'majorProphets', sortOrder: 25, numChapters: 48 },
    { name: 'Daniel', section: 'majorProphets', sortOrder: 26, numChapters: 12 },
    { name: 'Hosea', section: 'minorProphets', sortOrder: 27, numChapters: 14 },
    { name: 'Joel', section: 'minorProphets', sortOrder: 28, numChapters: 3 },
    { name: 'Amos', section: 'minorProphets', sortOrder: 29, numChapters: 9 },
    { name: 'Obadiah', section: 'minorProphets', sortOrder: 30, numChapters: 1 },
    { name: 'Jonah', section: 'minorProphets', sortOrder: 31, numChapters: 4 },
    { name: 'Micah', section: 'minorProphets', sortOrder: 32, numChapters: 7 },
    { name: 'Nahum', section: 'minorProphets', sortOrder: 33, numChapters: 3 },
    { name: 'Habakkuk', section: 'minorProphets', sortOrder: 34, numChapters: 3 },
    { name: 'Zephaniah', section: 'minorProphets', sortOrder: 35, numChapters: 3 },
    { name: 'Haggai', section: 'minorProphets', sortOrder: 36, numChapters: 2 },
    { name: 'Zechariah', section: 'minorProphets', sortOrder: 37, numChapters: 14 },
    { name: 'Malachi', section: 'minorProphets', sortOrder: 38, numChapters: 4 },
    { name: 'Matthew', section: 'gospelsAndActs', sortOrder: 39, numChapters: 28 },
    { name: 'Mark', section: 'gospelsAndActs', sortOrder: 40, numChapters: 16 },
    { name: 'Luke', section: 'gospelsAndActs', sortOrder: 41, numChapters: 24 },
    { name: 'John', section: 'gospelsAndActs', sortOrder: 42, numChapters: 21 },
    { name: 'Acts', section: 'gospelsAndActs', sortOrder: 43, numChapters: 28 },
    { name: 'Romans', section: 'paulineEpistles', sortOrder: 44, numChapters: 16 },
    { name: '1 Corinthians', section: 'paulineEpistles', sortOrder: 45, numChapters: 16 },
    { name: '2 Corinthians', section: 'paulineEpistles', sortOrder: 46, numChapters: 13 },
    { name: 'Galatians', section: 'paulineEpistles', sortOrder: 47, numChapters: 6 },
    { name: 'Ephesians', section: 'paulineEpistles', sortOrder: 48, numChapters: 6 },
    { name: 'Philippians', section: 'paulineEpistles', sortOrder: 49, numChapters: 4 },
    { name: 'Colossians', section: 'paulineEpistles', sortOrder: 50, numChapters: 4 },
    { name: '1 Thessalonians', section: 'paulineEpistles', sortOrder: 51, numChapters: 5 },
    { name: '2 Thessalonians', section: 'paulineEpistles', sortOrder: 52, numChapters: 3 },
    { name: '1 Timothy', section: 'paulineEpistles', sortOrder: 53, numChapters: 6 },
    { name: '2 Timothy', section: 'paulineEpistles', sortOrder: 54, numChapters: 4 },
    { name: 'Titus', section: 'paulineEpistles', sortOrder: 55, numChapters: 3 },
    { name: 'Philemon', section: 'paulineEpistles', sortOrder: 56, numChapters: 1 },
    { name: 'Hebrews', section: 'generalEpistles', sortOrder: 57, numChapters: 13 },
    { name: 'James', section: 'generalEpistles', sortOrder: 58, numChapters: 5 },
    { name: '1 Peter', section: 'generalEpistles', sortOrder: 59, numChapters: 5 },
    { name: '2 Peter', section: 'generalEpistles', sortOrder: 60, numChapters: 3 },
    { name: '1 John', section: 'generalEpistles', sortOrder: 61, numChapters: 5 },
    { name: '2 John', section: 'generalEpistles', sortOrder: 62, numChapters: 1 },
    { name: '3 John', section: 'generalEpistles', sortOrder: 63, numChapters: 1 },
    { name: 'Jude', section: 'generalEpistles', sortOrder: 64, numChapters: 1 },
    { name: 'Revelation', section: 'revelation', sortOrder: 65, numChapters: 22 }
] as const;

/**
 * Total number of chapters in the Bible (1189)
 */
export const BIBLE_TOTAL_CHAPTERS = BIBLE_BOOKS.reduce((sum, book) => sum + book.numChapters, 0);

/**
 * Calculate the position of a specific chapter as a percentage of the entire Bible (0-100)
 */
export function calculateBiblePositionPercent(bookName: BibleBook, chapter: number): number {
    let cumulativeChapters = 0;
    for (const book of BIBLE_BOOKS) {
        if (book.name === bookName) {
            // Use 0.5 offset to center the indicator on the chapter
            return ((cumulativeChapters + (chapter - 0.5)) / BIBLE_TOTAL_CHAPTERS) * 100;
        }
        cumulativeChapters += book.numChapters;
    }
    return 0;
}

// Map for efficient lookup of Bible books by name
export const BIBLE_BOOKS_MAP = new Map<BibleBook, BibleBookInfo>(
    BIBLE_BOOKS.map(book => [book.name, book])
);

// Map of book names to their sort order
export const BIBLE_BOOKS_SORT_ORDER: Record<string, number> = BIBLE_BOOKS.reduce((acc, book) => {
    acc[book.name] = book.sortOrder;
    return acc;
}, {} as Record<string, number>);

// Map of book names to short codes (for compact references)
export const BIBLE_BOOK_CODES: Record<BibleBook, string> = {
    // Old Testament - Pentateuch
    'Genesis': 'Gen',
    'Exodus': 'Exo',
    'Leviticus': 'Lev',
    'Numbers': 'Num',
    'Deuteronomy': 'Deu',

    // Old Testament - Historical
    'Joshua': 'Jos',
    'Judges': 'Jdg',
    'Ruth': 'Rut',
    '1 Samuel': '1Sa',
    '2 Samuel': '2Sa',
    '1 Kings': '1Ki',
    '2 Kings': '2Ki',
    '1 Chronicles': '1Ch',
    '2 Chronicles': '2Ch',
    'Ezra': 'Ezr',
    'Nehemiah': 'Neh',
    'Esther': 'Est',

    // Old Testament - Wisdom
    'Job': 'Job',
    'Psalm': 'Psa',
    'Proverbs': 'Pro',
    'Ecclesiastes': 'Ecc',
    'Song of Solomon': 'Sng',

    // Old Testament - Major Prophets
    'Isaiah': 'Isa',
    'Jeremiah': 'Jer',
    'Lamentations': 'Lam',
    'Ezekiel': 'Eze',
    'Daniel': 'Dan',

    // Old Testament - Minor Prophets
    'Hosea': 'Hos',
    'Joel': 'Joe',
    'Amos': 'Amo',
    'Obadiah': 'Oba',
    'Jonah': 'Jon',
    'Micah': 'Mic',
    'Nahum': 'Nah',
    'Habakkuk': 'Hab',
    'Zephaniah': 'Zep',
    'Haggai': 'Hag',
    'Zechariah': 'Zec',
    'Malachi': 'Mal',

    // New Testament - Gospels and Acts
    'Matthew': 'Mat',
    'Mark': 'Mar',
    'Luke': 'Luk',
    'John': 'Joh',
    'Acts': 'Act',

    // New Testament - Pauline Epistles
    'Romans': 'Rom',
    '1 Corinthians': '1Co',
    '2 Corinthians': '2Co',
    'Galatians': 'Gal',
    'Ephesians': 'Eph',
    'Philippians': 'Php',
    'Colossians': 'Col',
    '1 Thessalonians': '1Th',
    '2 Thessalonians': '2Th',
    '1 Timothy': '1Ti',
    '2 Timothy': '2Ti',
    'Titus': 'Tit',
    'Philemon': 'Phm',

    // New Testament - General Epistles
    'Hebrews': 'Heb',
    'James': 'Jas',
    '1 Peter': '1Pe',
    '2 Peter': '2Pe',
    '1 John': '1Jn',
    '2 John': '2Jn',
    '3 John': '3Jn',
    'Jude': 'Jud',

    // New Testament - Revelation
    'Revelation': 'Rev'
};

// Reverse map: short codes to full book names
export const BIBLE_CODE_TO_BOOK: Record<string, BibleBook> = {
    ...Object.entries(BIBLE_BOOK_CODES).reduce((acc, [book, code]) => {
        acc[code] = book as BibleBook;
        acc[code.toLowerCase()] = book as BibleBook; // Case-insensitive
        return acc;
    }, {} as Record<string, BibleBook>),
    // Additional common aliases and abbreviations
    // (Comprehensive: covers all CSB footnote abbreviations)
    'Ps': 'Psalm',
    'ps': 'Psalm',
    'Pss': 'Psalm',
    'pss': 'Psalm',
    'Is': 'Isaiah',
    'is': 'Isaiah',
    'Jn': 'John',
    'jn': 'John',
    'Mt': 'Matthew',
    'mt': 'Matthew',
    'Mk': 'Mark',
    'mk': 'Mark',
    'Lk': 'Luke',
    'lk': 'Luke',
    'Ac': 'Acts',
    'ac': 'Acts',
    'Ro': 'Romans',
    'ro': 'Romans',
    'Rm': 'Romans',
    'Gn': 'Genesis',
    'gn': 'Genesis',
    'Ex': 'Exodus',
    'ex': 'Exodus',
    'Lv': 'Leviticus',
    'lv': 'Leviticus',
    'Nm': 'Numbers',
    'nm': 'Numbers',
    'Dt': 'Deuteronomy',
    'dt': 'Deuteronomy',
    'Js': 'Joshua',
    'js': 'Joshua',
    'Jos': 'Joshua',
    'Jg': 'Judges',
    'jg': 'Judges',
    'Jdg': 'Judges',
    'Rt': 'Ruth',
    'rt': 'Ruth',
    'Ru': 'Ruth',
    '1S': '1 Samuel',
    '1Sm': '1 Samuel',
    '2S': '2 Samuel',
    '2Sm': '2 Samuel',
    '1K': '1 Kings',
    '1Kg': '1 Kings',
    '2K': '2 Kings',
    '2Kg': '2 Kings',
    '1C': '1 Chronicles',
    '1Ch': '1 Chronicles',
    '2C': '2 Chronicles',
    '2Ch': '2 Chronicles',
    'Ez': 'Ezra',
    'ez': 'Ezra',
    'Ezr': 'Ezra',
    'Ne': 'Nehemiah',
    'ne': 'Nehemiah',
    'Neh': 'Nehemiah',
    'Es': 'Esther',
    'es': 'Esther',
    'Est': 'Esther',
    'Jb': 'Job',
    'Pr': 'Proverbs',
    'pr': 'Proverbs',
    'Ec': 'Ecclesiastes',
    'ec': 'Ecclesiastes',
    'Sn': 'Song of Solomon',
    'sn': 'Song of Solomon',
    'Sg': 'Song of Solomon',
    'Jr': 'Jeremiah',
    'jr': 'Jeremiah',
    'Lm': 'Lamentations',
    'lm': 'Lamentations',
    'Ezk': 'Ezekiel',
    'Dn': 'Daniel',
    'dn': 'Daniel',
    'Ho': 'Hosea',
    'ho': 'Hosea',
    'Hs': 'Hosea',
    'Jl': 'Joel',
    'jl': 'Joel',
    'Am': 'Amos',
    'am': 'Amos',
    'Ob': 'Obadiah',
    'ob': 'Obadiah',
    'Jh': 'Jonah',
    'jh': 'Jonah',
    'Jnh': 'Jonah',
    'Mi': 'Micah',
    'mi': 'Micah',
    'Mc': 'Micah',
    'Na': 'Nahum',
    'na': 'Nahum',
    'Nah': 'Nahum',
    'Hb': 'Habakkuk',
    'hb': 'Habakkuk',
    'Hab': 'Habakkuk',
    'Zp': 'Zephaniah',
    'zp': 'Zephaniah',
    'Zph': 'Zephaniah',
    'Hg': 'Haggai',
    'hg': 'Haggai',
    'Zc': 'Zechariah',
    'zc': 'Zechariah',
    'Zch': 'Zechariah',
    'Ml': 'Malachi',
    'ml': 'Malachi',
    'Mal': 'Malachi',
    'Ga': 'Galatians',
    'ga': 'Galatians',
    'Gl': 'Galatians',
    'Ep': 'Ephesians',
    'ep': 'Ephesians',
    'Eph': 'Ephesians',
    'Pp': 'Philippians',
    'pp': 'Philippians',
    'Php': 'Philippians',
    'Cl': 'Colossians',
    'cl': 'Colossians',
    'Col': 'Colossians',
    '1T': '1 Timothy',
    '1Tm': '1 Timothy',
    '1Th': '1 Thessalonians',
    '2T': '2 Timothy',
    '2Tm': '2 Timothy',
    '2Th': '2 Thessalonians',
    'Ti': 'Titus',
    'ti': 'Titus',
    'Pm': 'Philemon',
    'pm': 'Philemon',
    'Phm': 'Philemon',
    'He': 'Hebrews',
    'he': 'Hebrews',
    'Heb': 'Hebrews',
    'Ja': 'James',
    'ja': 'James',
    'Jms': 'James',
    '1P': '1 Peter',
    '1Pt': '1 Peter',
    '2P': '2 Peter',
    '2Pt': '2 Peter',
    '1J': '1 John',
    '1Jn': '1 John',
    '2J': '2 John',
    '2Jn': '2 John',
    '3J': '3 John',
    '3Jn': '3 John',
    'Ju': 'Jude',
    'ju': 'Jude',
    'Jd': 'Jude',
    '1Co': '1 Corinthians',
    '2Co': '2 Corinthians',
    'Re': 'Revelation',
    're': 'Revelation',
    'Rv': 'Revelation'
};

export const DEFAULT_VIEW: { version: BibleVersion; book: BibleBook; chapter: number } = {
    version: 'csb',
    book: 'Genesis',
    chapter: 1
};

// Bible section colors (Christian canonical divisions)
export const BIBLE_SECTION_COLORS: Record<BibleSection, string> = {
    pentateuch: 'border-l-blue-600',         // Torah - Deep Blue
    historical: 'border-l-green-600',        // Historical - Forest Green
    wisdom: 'border-l-purple-500',           // Wisdom - Purple
    majorProphets: 'border-l-indigo-500',    // Major Prophets - Indigo
    minorProphets: 'border-l-teal-500',      // Minor Prophets - Teal
    gospelsAndActs: 'border-l-red-500',      // Gospels & Acts - Red
    paulineEpistles: 'border-l-orange-500',  // Pauline Epistles - Orange
    generalEpistles: 'border-l-amber-500',   // General Epistles - Amber
    revelation: 'border-l-yellow-500'        // Revelation - Yellow
};

export function getBookSectionColor(bookName: BibleBook): string {
    const bookInfo = BIBLE_BOOKS_MAP.get(bookName);
    if (bookInfo) {
        return BIBLE_SECTION_COLORS[bookInfo.section];
    }
    return 'border-l-gray-500';
}

/**
 * Parse a paragraph reference to extract book and chapter.
 * Reference format: "Gen:1:1:2:3" (Genesis 1:1 - 2:3)
 * Returns the starting book and chapter.
 * @param reference - The paragraph reference string
 * @returns Object containing the book name and chapter number
 */
export function parseReference(reference: string): { book: BibleBook; chapter: number } {
    const parts = reference.split(':');
    const book = BIBLE_CODE_TO_BOOK[parts[0]];
    const chapter = parseInt(parts[1], 10);
    return { book, chapter };
}

/**
 * Format a passage reference with spaces around the dash when spanning chapters.
 * Reference format: "1:1-8" (same chapter) or "1:1-2:8" (different chapters)
 * @param ref - The reference string to format
 * @returns Formatted reference string with spaces around dash for multi-chapter refs
 * @example
 * formatRef("1:1-8") // returns "1:1-8"
 * formatRef("1:1-2:8") // returns "1:1 - 2:8"
 */
export function formatRef(ref: string): string {
    // Check if ref spans chapters (has format like "1:1-2:3")
    // vs single chapter (has format like "2:4-15")
    if (ref.includes(':') && ref.split('-')[1]?.includes(':')) {
        // Multi-chapter: add spaces around dash
        return ref.replace('-', ' - ');
    }
    // Single chapter: keep as-is
    return ref;
}

/**
 * Normalizes a book name for display.
 * Specifically converts "Psalm" to "Psalms" for standalone display.
 * Also handles common abbreviations.
 * @param bookName - The book name or abbreviation (e.g., "Psalm", "Ps")
 * @returns The normalized book name for display (e.g., "Psalms")
 */
export function normalizeBookName(bookName: string | undefined): string {
    if (!bookName) return '';

    // First try to look up in our code map (handles Ps, Is, etc.)
    const codeMatch = BIBLE_CODE_TO_BOOK[bookName] || BIBLE_CODE_TO_BOOK[bookName.trim()];
    const name = codeMatch || bookName;

    if (name === 'Psalm') return 'Psalms';
    return name;
}

/**
 * Gets the canonical BibleBook name from a display name or abbreviation.
 * Handles "Psalms" -> "Psalm" and aliases like "Ps" -> "Psalm".
 * @param name - The book name or abbreviation
 * @returns The canonical BibleBook name or the original string if not found
 */
export function getCanonicalBookName(name: string): string {
    if (!name) return name;

    // Special case for display name to canonical
    if (name === 'Psalms') return 'Psalm';

    // Try code map
    const codeMatch = BIBLE_CODE_TO_BOOK[name] || BIBLE_CODE_TO_BOOK[name.trim()] || BIBLE_CODE_TO_BOOK[name.toLowerCase()];
    return codeMatch || name;
}